import { req } from '../../@api/request';

export default class InquiryService {
  static inquiry = async (data: any) => {
    const result = await req.post('/inquiry', data);
    return result.data;
  };
}
